export const pharmacyLogos: Record<string, string> = {
  Albertsons: "https://static.modernatx.com/ui/pharmacy-logos/albertsons-logo.webp",
  "Baker's": "https://static.modernatx.com/ui/pharmacy-logos/kroger-bakers-logo.webp",
  "City Market": "https://static.modernatx.com/ui/pharmacy-logos/kroger-city-market-logo.webp",
  Costco: "https://static.modernatx.com/ui/pharmacy-logos/costco-logo.webp",
  CVS: "https://static.modernatx.com/ui/pharmacy-logos/cvs-pharmacy-logo.webp",
  "CVS Pharmacy": "https://static.modernatx.com/ui/pharmacy-logos/cvs-pharmacy-logo.webp",
  "Fred Meyer": "https://static.modernatx.com/ui/pharmacy-logos/kroger-fred-meyer-logo.webp",
  "Fry's Food": "https://static.modernatx.com/ui/pharmacy-logos/kroger-frys-logo.webp",
  "Jewel Osco": "https://static.modernatx.com/ui/pharmacy-logos/albertsons-jewel-osco-logo.webp",
  "King Soopers": "https://static.modernatx.com/ui/pharmacy-logos/kroger-king-soopers-logo.webp",
  Kroger: "https://static.modernatx.com/ui/pharmacy-logos/kroger-logo.webp",
  QFC: "https://static.modernatx.com/ui/pharmacy-logos/kroger-qfc-logo.webp",
  "Rite Aid": "https://static.modernatx.com/ui/pharmacy-logos/rite-aid-logo.webp",
  Safeway: "https://static.modernatx.com/ui/pharmacy-logos/albertsons-safeway-logo.webp",
  "Safeway Pharmacy": "https://static.modernatx.com/ui/pharmacy-logos/albertsons-safeway-logo.webp",
  Shaws: "https://static.modernatx.com/ui/pharmacy-logos/shaws-logo.webp",
  Walgreens: "https://static.modernatx.com/ui/pharmacy-logos/walgreens-logo.webp",
  Walmart: "https://static.modernatx.com/ui/pharmacy-logos/walmart-logo.webp",
  "Wal-Mart": "https://static.modernatx.com/ui/pharmacy-logos/walmart-logo.webp",
  "Wm Supercenter": "https://static.modernatx.com/ui/pharmacy-logos/walmart-logo.webp"
};

export const pharmacyLogosAdditionalPadding: Record<string, string> = {
  Costco: "1rem"
};
